function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.2601 11.4609C9.3987 11.6537 8.57662 11.9947 7.83008 12.4689",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.1703 12.4791C15.4238 12.0048 14.6017 11.6639 13.7402 11.4711",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.6299 17.3981C19.4386 16.5298 19.1003 15.7011 18.6299 14.9486",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.37988 14.9486C4.90943 15.7011 4.57114 16.5298 4.37988 17.3981",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.8704 19.656C15.8857 19.4884 15.8857 19.3197 15.8704 19.152C15.8704 18.1067 15.4584 17.1043 14.7252 16.3651C13.9919 15.626 12.9974 15.2107 11.9604 15.2107C10.9234 15.2107 9.9289 15.626 9.19563 16.3651C8.46237 17.1043 8.05049 18.1067 8.05049 19.152C8.03525 19.3197 8.03525 19.4884 8.05049 19.656",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.2598 11.461V9.07202H13.7398V11.461",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.1602 12.479L17.8402 10.7855L20.3002 13.2652L18.6202 14.9586",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.6299 17.3981H21.9999V19.656",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2 19.656V17.3981H4.37",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.3802 14.9586L3.7002 13.2652L6.1602 10.7855L7.8302 12.479",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.5 0.504028H23.5V18.648C23.5 18.9154 23.3946 19.1718 23.2071 19.3608C23.0196 19.5498 22.7652 19.656 22.5 19.656H1.5C1.23478 19.656 0.98043 19.5498 0.792893 19.3608C0.605357 19.1718 0.5 18.9154 0.5 18.648V0.504028Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.5 4.53601H23.5",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("mask", {
  id: "path-13-inside-1",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.5 3.02399C3.77614 3.02399 4 2.79834 4 2.51999C4 2.24164 3.77614 2.01599 3.5 2.01599C3.22386 2.01599 3 2.24164 3 2.51999C3 2.79834 3.22386 3.02399 3.5 3.02399Z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M3.5 3.02399C3.77614 3.02399 4 2.79834 4 2.51999C4 2.24164 3.77614 2.01599 3.5 2.01599C3.22386 2.01599 3 2.24164 3 2.51999C3 2.79834 3.22386 3.02399 3.5 3.02399Z",
  fill: "#828282"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3 2.51999C3 2.25358 3.21636 2.02399 3.5 2.02399V4.02399C4.33592 4.02399 5 3.3431 5 2.51999H3ZM3.5 2.02399C3.78364 2.02399 4 2.25358 4 2.51999H2C2 3.3431 2.66408 4.02399 3.5 4.02399V2.02399ZM4 2.51999C4 2.7864 3.78364 3.01599 3.5 3.01599V1.01599C2.66408 1.01599 2 1.69688 2 2.51999H4ZM3.5 3.01599C3.21636 3.01599 3 2.7864 3 2.51999H5C5 1.69688 4.33592 1.01599 3.5 1.01599V3.01599Z",
  fill: "#828282",
  mask: "url(#path-13-inside-1)"
}), /*#__PURE__*/React.createElement("mask", {
  id: "path-15-inside-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.5 3.02399C5.77614 3.02399 6 2.79834 6 2.51999C6 2.24164 5.77614 2.01599 5.5 2.01599C5.22386 2.01599 5 2.24164 5 2.51999C5 2.79834 5.22386 3.02399 5.5 3.02399Z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M5.5 3.02399C5.77614 3.02399 6 2.79834 6 2.51999C6 2.24164 5.77614 2.01599 5.5 2.01599C5.22386 2.01599 5 2.24164 5 2.51999C5 2.79834 5.22386 3.02399 5.5 3.02399Z",
  fill: "#828282"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5 2.51999C5 2.25359 5.21636 2.02399 5.5 2.02399V4.02399C6.33592 4.02399 7 3.3431 7 2.51999H5ZM5.5 2.02399C5.78364 2.02399 6 2.25359 6 2.51999H4C4 3.3431 4.66408 4.02399 5.5 4.02399V2.02399ZM6 2.51999C6 2.7864 5.78364 3.01599 5.5 3.01599V1.01599C4.66408 1.01599 4 1.69688 4 2.51999H6ZM5.5 3.01599C5.21636 3.01599 5 2.7864 5 2.51999H7C7 1.69688 6.33592 1.01599 5.5 1.01599V3.01599Z",
  fill: "#828282",
  mask: "url(#path-15-inside-2)"
}), /*#__PURE__*/React.createElement("mask", {
  id: "path-17-inside-3",
  fill: "white"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.5 3.02399C7.77614 3.02399 8 2.79834 8 2.51999C8 2.24164 7.77614 2.01599 7.5 2.01599C7.22386 2.01599 7 2.24164 7 2.51999C7 2.79834 7.22386 3.02399 7.5 3.02399Z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M7.5 3.02399C7.77614 3.02399 8 2.79834 8 2.51999C8 2.24164 7.77614 2.01599 7.5 2.01599C7.22386 2.01599 7 2.24164 7 2.51999C7 2.79834 7.22386 3.02399 7.5 3.02399Z",
  fill: "#828282"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 2.51999C7 2.25358 7.21636 2.02399 7.5 2.02399V4.02399C8.33592 4.02399 9 3.3431 9 2.51999H7ZM7.5 2.02399C7.78364 2.02399 8 2.25358 8 2.51999H6C6 3.3431 6.66408 4.02399 7.5 4.02399V2.02399ZM8 2.51999C8 2.7864 7.78364 3.01599 7.5 3.01599V1.01599C6.66408 1.01599 6 1.69688 6 2.51999H8ZM7.5 3.01599C7.21636 3.01599 7 2.7864 7 2.51999H9C9 1.69688 8.33592 1.01599 7.5 1.01599V3.01599Z",
  fill: "#828282",
  mask: "url(#path-17-inside-3)"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 20.16,
  fill: "white"
})));

var SvgDashboard = function SvgDashboard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDashboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dashboard.fb392939.svg";
export { ForwardRef as ReactComponent };